<template>
  <div class="dialog-bg" @click.self="onConfirm(false)">
    <div class="dialog-box">
      <div class="header">{{ header }}</div>
      <div
        class="material"
        v-for="(material, index) in materialCodeList"
        :key="index"
      >
        <div class="title">{{ material.title }}:</div>
        <div v-for="(variant, vIndex) in material.materialList" :key="vIndex">
          <div class="detail">{{ variant.fullDescription }}</div>
        </div>
      </div>
      <div class="button-submit">
        <div class="text-right mt-5">
          <sc-button
            variant="danger"
            @click="handleClickCancel"
            size="sm"
          >ยกเลิก</sc-button
          >
          <sc-button
            variant="primary"
            @click="handleClickSave"
            size="sm"
          >บันทึก</sc-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ScButton from "@/lib/components/ScButton";

export default {
  components: {
    ScButton,
  },
  props: ["value"],
  data() {
    return {
      from: null,
      materialCodeList: [],
      header: 'ยืนยันการสร้างบริการ'
    };
  },
  computed: {},
  created() {
    this.setup();
  },
  methods: {
    setup() {
      const isMaterialCodeToOptions =
        this.value.serviceOptions &&
        this.value.serviceOptions.length > 0 &&
        this.value.serviceOptions.filter((service) =>
          service.variants.some((variant) => variant.material_code)
        );

      const materialCodeToOptions = isMaterialCodeToOptions
        ? this.value.serviceOptions.map((serviceOption) => {
            const variants = serviceOption.variants.filter(
              (variant) => variant.material_code
            );

            return {
              ...serviceOption,
              variants,
            };
          })
        : undefined;

      let materialCodeList;
      if (this.value.materialCode) {
        // กรณีมี Material Code ที่ระดับ service
        const material = {
          description: this.value.codeDescriptionUnit,
          quantity: this.value.materialQuantity,
          unitName: this.value.unitName,
          title: "",
          fullDescription: `${this.value.codeDescriptionUnit} (จำนวน ${this.value.materialQuantity} ${this.value.unitName})`,
        };

        materialCodeList = [
          {
            title: this.value.name,
            materialList: [material],
          },
        ];
      } else if (isMaterialCodeToOptions) {
        // กรณีมี Material Code ที่ระดับ option
        materialCodeList = materialCodeToOptions.map((matCode) => {
          const materialList = matCode.variants.map((variant) => {
            const fullDescription = `${variant.title}:  ${variant.code_description_unit} (จำนวน ${variant.material_quantity} ${variant.unit_name})`;
            return {
              description: variant.code_description_unit,
              quantity: variant.material_quantity,
              unitName: variant.unit_name,
              title: variant.title,
              fullDescription,
            };
          });

          return {
            title: matCode.title,
            materialList,
          };
        });
      } else {
        // ถ้าไม่มีการใส่ Material Code ให้ส่งออกไปบันทึกข้อมูล service
        this.$emit("confirmToSaveService", true);
      }

      this.materialCodeList = materialCodeList;

      if (materialCodeList) {
        this.header = 'ยืนยันรายการ Material Code'
      }
    },
    handleClickCancel() {
      this.$emit("confirmMaterialCode", false);
    },
    handleClickSave() {
      this.$emit("confirmMaterialCode", true);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.dialog-box {
  padding: 0;
  border-radius: 15px;
  position: absolute;
  background-color: #fcfcfc;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.header {
  font-size: 22px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: -0.1px;
  text-align: center;
  color: #000;
  background-color: #c5c2c2;
  padding: 24px 40px;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
}

.title {
  font-size: 18px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: -0.1px;
  padding-top: 24px;
  padding-left: 40px;
  padding-right: 40px;
}

.detail {
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: -0.1px;
  padding-left: 50px;
}

.detail-inline {
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: -0.1px;
  padding-left: 50px;
  display: inline;
}

.material {
  padding-right: 40px;
}

.button-submit {
  margin-bottom: 10px;
  margin-right: 10px;
}
</style>


// WEBPACK FOOTER //
// src/features/subscriptions/modules/services/components/ServiceConfirmMaterialCode.vue